import { HawaPanel } from '../types'

import component from './historical-trend.component.vue'
import editor from './historical-trend.editor.vue'

export default class HistorycalTrend implements HawaPanel {
  name = 'HistorycalTrend'
  title = 'Historical Trend'
  component = component
  editor = editor
  snapshot = {
    title: 'Historycal Trend',
    attributes: {
      panelHeader: {
        show: false,
        style: {},
      },
    },
    layout: { i: '1591166209124', h: 24, w: 480, x: 0, y: 0, moved: false },
    query: [],
    options: {
      grid: {
        left: '5px',
        right: '5px',
        bottom: '5px',
        top: '5px',
      },
      animation: false,
      xAxis: {
        type: 'time',
        splitLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%'],
        splitLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
      },
      series: [
        {
          name: 'PM10',
          tag: 'KHbnfkCWk',
          color: 'rgb(251,18,18)',
          type: 'line',
          smooth: true,
          showSymbol: false,
          hoverAnimation: false,
          lineStyle: { width: 1 },
          data: [
            ['2020-06-04T01:16:18Z', 35.04395927863578],
            ['2020-06-04T01:16:21Z', 37.35268696066097],
            ['2020-06-04T01:16:24Z', 38.52244447492254],
            ['2020-06-04T01:16:27Z', 49.26957500623159],
            ['2020-06-04T01:16:30Z', 44.22670898403271],
            ['2020-06-04T01:16:33Z', 43.890291898303516],
            ['2020-06-04T01:16:36Z', 52.11691885845939],
            ['2020-06-04T01:16:39Z', 37.93963215036745],
            ['2020-06-04T01:16:42Z', 38.98307646226937],
            ['2020-06-04T01:16:45Z', 40.76002140271879],
            ['2020-06-04T01:16:48Z', 52.45212024960556],
            ['2020-06-04T01:16:51Z', 35.63581374993327],
          ],
        },
        {
          name: 'PM2.5',
          tag: '_Ib7BkjWz',
          color: 'rgb(20,34,233)',
          type: 'line',
          smooth: true,
          showSymbol: false,
          hoverAnimation: false,
          lineStyle: { width: 1 },
          data: [
            ['2020-06-04T01:16:18Z', 46.45316657152554],
            ['2020-06-04T01:16:21Z', 41.37700843231033],
            ['2020-06-04T01:16:24Z', 40.701229174532926],
            ['2020-06-04T01:16:27Z', 46.45316714445628],
            ['2020-06-04T01:16:30Z', 40.74197937500179],
            ['2020-06-04T01:16:33Z', 42.1407426410406],
            ['2020-06-04T01:16:36Z', 38.62346567016997],
            ['2020-06-04T01:16:39Z', 54.01333072195697],
            ['2020-06-04T01:16:42Z', 41.735617888994646],
            ['2020-06-04T01:16:45Z', 48.798052907055535],
            ['2020-06-04T01:16:48Z', 42.46808723851905],
            ['2020-06-04T01:16:51Z', 35.58165019641077],
          ],
        },
        {
          name: 'NOX',
          tag: 't7b7BzCWz',
          color: 'rgb(207,218,150)',
          type: 'line',
          smooth: true,
          showSymbol: false,
          hoverAnimation: false,
          lineStyle: { width: 1 },
          data: [
            ['2020-06-04T01:16:18Z', 48.713355559754525],
            ['2020-06-04T01:16:21Z', 53.879578198178294],
            ['2020-06-04T01:16:24Z', 38.07080283056104],
            ['2020-06-04T01:16:27Z', 49.51725599529901],
            ['2020-06-04T01:16:30Z', 52.32952047787122],
            ['2020-06-04T01:16:33Z', 37.96891102829616],
            ['2020-06-04T01:16:36Z', 42.214359844389605],
            ['2020-06-04T01:16:39Z', 39.670225624616954],
            ['2020-06-04T01:16:42Z', 48.1143870673915],
            ['2020-06-04T01:16:45Z', 45.42991784496108],
            ['2020-06-04T01:16:48Z', 51.41686833831942],
            ['2020-06-04T01:16:51Z', 49.39965539308645],
          ],
        },
      ],
    },
  }
  init = {
    attributes: {
      updateOnPageOpen: true,
      panelHeader: {
        show: false,
        style: {},
      },

      chartOptions: {
        grid: {
          left: 50,
          right: 50,
          bottom: 80,
          top: 60,
        },
        animation: false,
        xAxis: {
          type: 'time',
          splitLine: { show: true },
          axisLabel: { show: true },
          axisTick: { show: true },
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: { show: true },
          axisLabel: { show: true },
          axisTick: { show: true },
        },

        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 20,
          },
        ],
      },
      query: [],
    },
    layout: { i: '1591166209124', h: 70, w: 480, x: 0, y: 0, moved: false },
    query: [],
  }
}
